/**
 * BlogTool JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class BlogTool
 */
class BlogTool {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$subscribeBtn = $( '.js-blog-tool-subscribe' );
    }

    /**
     * All blog tool related events
     * @return {void}
     */
    events() {
        this.$subscribeBtn.on( 'click', ( e ) => {
            this.subscribe( e );
        });
    }

    subscribe( e ) {
        e.preventDefault();

        // Get the form.
        const $form = $( e.target ).closest( '.js-blog-tool-form' );

        // Get email.
        const email = $form.find( '#email' ).val();

        // Get form message.
        const $message = $form.children( '.js-blog-tool-message' );

        if ( this.validateEmail( email ) ) {
            dp( 'BlogToolSubscribe', {
                tidy: true,
                data: true,
                args: {
                    email: email
                },
                success: () => {
                    $message.text( blogToolStrings.subscription_success );
                },
                error: ( error ) => {
                    $message.text( blogToolStrings.subscription_error );

                    console.error( error );
                }
            });
        } else {
            $message.text( blogToolStrings.invalid_email );
        }

        $message.css( 'display', 'inline-block' );
    }

    /**
     * Validate email.
     *
     * @link https://www.w3resource.com/javascript/form/email-validation.php
     * @param {string} email Email address.
     */
    validateEmail( email ) {
        if ( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( email ) ) {
          return true;
        }

        return false;
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = BlogTool;



// WEBPACK FOOTER //
// ./assets/scripts/blog-tool.js